import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {CardAction, ScottyCardComponent} from "../scotty-card/scotty-card.component";

export enum DetailCardContent {
  EMPTY,
  SINGLE_CONTENT,
  TABS
}

@Component({
  selector: 'app-detail-card',
  templateUrl: './detail-card.component.html',
  styleUrls: ['./detail-card.component.scss']
})
export class DetailCardComponent implements OnInit {

  private _isLoading: boolean;

  @Input() set isLoading(value: boolean) {

    if (this._isLoading != value) {
      this._isLoading = value;
      this.cdr.detectChanges();
      this.reloadCardActions();
    } else {
      this._isLoading = value;
    }

  }

  get isLoading() {
    return this._isLoading;
  }

  @Input()
  contentToShow: DetailCardContent;

  @Input()
  backLevels = 1;

  @Input()
  title: string;

  @Input()
  image: string;

  @Input()
  generateQRCode: boolean;

  @Input()
  canUploadImage: boolean;

  @Input()
  tabs: { name: string, content: TemplateRef<any> }[];

  @Input()
  actions: CardAction[];

  @Output()
  onUploadImageClick = new EventEmitter<boolean>();

  @ViewChild(ScottyCardComponent, { static: false })
  appCard: ScottyCardComponent;

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  hasScrollbar(element: HTMLElement) {
    return element.scrollHeight > element.clientHeight;
  }

  reloadCardActions() {
    this.appCard.reloadCardActions();
  }

  get DetailCardContent() { return DetailCardContent; }

}
